import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import useSession from '../hooks/useSession'
import { useSelector } from 'react-redux'
import { isLogisticaOnly } from '../helpers/logisticaHelper'

export default function PublicRoute(props) {
  const { restricted } = props

  const location = useLocation()
  const [isLoggedIn] = useSession()
  const { roles } = useSelector(state => state.account)

  if (isLoggedIn && (roles?.includes('Vendedor') || roles?.includes('Admin Ventas'))) {
    return (
      <Navigate to={"/lista-clientes"} replace />
    )
  }
  if (isLoggedIn && isLogisticaOnly(roles)) {
    return (
      <Navigate to={"/logistica"} replace />
    )
  }
  return (
    isLoggedIn && restricted ?
      <Navigate to={location.state?.redir ?? "/products"} replace />
      : <Outlet />
  )
}